import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SponsorModalComponent } from 'components/modal/sponsor-modal/sponsor-modal.component';
import { AuthorizationService } from 'services/authorization.service';
import { VersionResponse } from 'types/version.interface';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule, SponsorModalComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  version = '';
  constructor(public authService: AuthorizationService) {}
  ngOnInit(): void {
    this.loadVersionFromLocalStorage();
  }

  private loadVersionFromLocalStorage() {
    const versionStr = localStorage.getItem('versionInfo');
    if (versionStr) {
      try {
        this.version = (JSON.parse(versionStr) as VersionResponse).version;
      } catch (err) {
        console.error('Error parsing version info from localStorage:', err);
      }
    } else {
      this.authService.getVersionInfo().subscribe({
        next: (v) => {
          this.version = v.version;
          localStorage.setItem('versionInfo', JSON.stringify(v));
        },
        error: (err) => console.error('Error fetching version info:', err)
      });
    }
  }
}
